import React from 'react'

function Undo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.106 5.106A9.722 9.722 0 0112 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75a9.722 9.722 0 01-6.894-2.856.75.75 0 011.06-1.06 8.25 8.25 0 100-11.667c-.4.399-1.046 1.102-1.603 1.716a164.716 164.716 0 00-.924 1.027l-.078.088L3 8.5l-.56-.498.08-.09a145.24 145.24 0 01.932-1.037c.553-.61 1.224-1.34 1.654-1.77zM2.502 9.06a.75.75 0 01-.063-1.059L3 8.5l.561.498a.75.75 0 01-1.059.063z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3 3.75a.75.75 0 01.75.75v3.25H7a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75v-4A.75.75 0 013 3.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Undo
